import React from 'react';
import { PortalLink } from 'apps/client/components/PortalLink';

import { graphqlIdToDecimal } from 'utils/dgraphId';

// { rfqId: rfq.id }

export function makeDecimalIdLink({
  routeName,
  paramName,
  prefix = '',
}: {
  routeName: string;
  paramName: string;
  prefix?: string;
}) {
  return function DecimalIdLink(id: string) {
    if (!id) {
      return null;
    }
    const decimalId = graphqlIdToDecimal(id);
    const routeParams = { [paramName]: decimalId };
    return (
      <PortalLink name={routeName} params={routeParams}>
        {prefix + decimalId}
      </PortalLink>
    );
  };
}
